import { render, staticRenderFns } from "./ProjectLocation.vue?vue&type=template&id=b2a08b94&scoped=true"
var script = {}
import style0 from "./ProjectLocation.vue?vue&type=style&index=0&id=b2a08b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a08b94",
  null
  
)

export default component.exports